import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BreadcrumbRadioButtonView, BreadcrumbReset, Cancel_EwayBillSuccess, commonPageFieldList, commonPageFieldListSuccess, getpdfReportdata, InvoiceSendToScm, InvoiceSendToScmSuccess, Uploaded_EwayBillSuccess, } from "../../../store/actions";
import { Col, FormGroup, Label } from "reactstrap";
import Select from "react-select";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import { GetVenderSupplierCustomer } from "../../../store/CommonAPI/SupplierRedux/actions";
import { date_ymd_func, getOrderVisibilitySetting, isFoodERPDotIn, isPartyInOrderVisibilitySetting, isRACompany, IsSweetAndSnacksCompany, loginSelectedPartyID } from "../../../components/Common/CommonFunction";
import { useHistory } from "react-router-dom";
import { deleteChallanId, deleteChallanIdSuccess, challanList_ForListPage, challanMasterBulkAction, challanList_ForListPageSuccess, challanMasterBulkSuccess, } from "../../../store/Inventory/ChallanRedux/actions";
import { makeGRN_Mode_1Action } from "../../../store/Inventory/GRNRedux/actions";
import Challan from "./IBInvoice";
import { C_DatePicker } from "../../../CustomValidateForm";
import { url, mode, pageId } from "../../../routes/index"
import { C_Button, Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import { allLabelWithBlank } from "../../../components/Common/CommonErrorMsg/HarderCodeData";
import * as report from '../../../Reports/ReportIndex'
import { IB_Invoice_Singel_Get_for_Report_Api } from "../../../helpers/backend_helper";
import useCheckStockEntry from "../../../components/Common/commonComponent/CheckStockEntry";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";

const IBInvoiceList = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const currentDate_ymd = date_ymd_func();
    const selectedChallanIdsRef = React.useRef(new Set());
    const lastFetchedPartyIdRef = React.useRef(null);
    const [subPageMode] = useState(history.location.pathname);
    const [pageMode, setPageMode] = useState(mode.defaultList);
    const [otherState, setOtherState] = useState({ masterPath: '', makeBtnShow: false, newBtnPath: '' });
    const [hederFilters, setHederFilters] = useState({ fromdate: currentDate_ymd, todate: currentDate_ymd, venderSelect: allLabelWithBlank })
    const reducers = useSelector(
        (state) => ({
            vendorSupplierCustomer: state.CommonAPI_Reducer.vendorSupplierCustomer,
            vender: state.CommonAPI_Reducer.vender,
            tableList: state.ChallanReducer.ChallanList,
            listBtnLoading: (state.InvoiceReducer.listBtnLoading || state.ChallanReducer.goBtnLoading || state.PdfReportReducers.ReportBtnLoading || state.ChallanReducer.listBtnLoading),
            deleteMsg: state.ChallanReducer.deleteMsg,
            updateMsg: state.GRNReducer.updateMsg,
            postMsg: state.GRNReducer.postMsg,
            challansuccess: state.ChallanReducer.postMsg,
            editData: state.GRNReducer.editData,
            makeGRN: state.GRNReducer.GRNitem,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageFieldList,
            challanBulkData: state.ChallanReducer.challanBulkData,
            Uploaded_EwayBill: state.InvoiceReducer.Uploaded_EwayBill,
            Cancel_EwayBill: state.InvoiceReducer.Cancel_EwayBill,
            sendToScmMsg: state.InvoiceReducer.sendToScmMsg,
            goBtnLoading: state.ChallanReducer.goBtnLoading,
            bulkInvoiceLoading: state.ChallanReducer.bulkInvoiceLoading,
        })
    );

    const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);
    const isChallanList = subPageMode === url.CHALLAN_MASTER_LIST;

    const { pageField, vender, makeGRN, deleteMsg, vendorSupplierCustomer, Uploaded_EwayBill, Cancel_EwayBill, sendToScmMsg } = reducers;
    const { fromdate, todate, venderSelect } = hederFilters;

    const action = {
        deleteId: deleteChallanId,
        deleteSucc: deleteChallanIdSuccess
    }

    // Featch Modules List data  First Rendering
    useEffect(() => {
        let page_Id = '';
        let page_Mode = mode.defaultList;
        let masterPath = '';
        let makeBtnShow = false
        let newBtnPath = ''


        if (subPageMode === url.IB_INVOICE_LIST) {
            page_Id = pageId.IB_INVOICE_LIST;
            masterPath = url.IB_INVOICE;
            newBtnPath = url.IB_INVOICE;
            page_Mode = mode.modeSTPList
            makeBtnShow = true;
        }
        else if (subPageMode === url.CHALLAN_MASTER_LIST) {
            page_Id = pageId.CHALLAN_MASTER_LIST;
            masterPath = url.CHALLAN_MASTER;
            newBtnPath = url.CHALLAN_MASTER;
            page_Mode = mode.modeSTPList
            makeBtnShow = true;
        }
        else if (subPageMode === url.VDC_INVOICE_LIST) {
            page_Id = pageId.VDC_INVOICE_LIST;
            masterPath = url.VDC_INVOICE;
            newBtnPath = url.VDC_INVOICE;
            page_Mode = mode.modeSTPList


        } else if (subPageMode === url.IB_INVOICE_FOR_GRN) {
            page_Id = pageId.IB_INVOICE_FOR_GRN;
            masterPath = url.VDC_INVOICE;
            page_Mode = mode.modeSTPList

        }


        setOtherState({ masterPath, makeBtnShow, newBtnPath })
        setPageMode(page_Mode)
        dispatch(BreadcrumbRadioButtonView(true));
        dispatch(commonPageFieldListSuccess(null))
        dispatch(commonPageFieldList(page_Id))
        // dispatch(GetVender())
        const initialPartyId = (commonPartyDropSelect.value === 0) ? loginSelectedPartyID() : commonPartyDropSelect.value;
        if (initialPartyId !== 0) {
            dispatch(GetVenderSupplierCustomer({ subPageMode, RouteID: "", "PartyID": initialPartyId }));
            goButtonHandler()
            lastFetchedPartyIdRef.current = initialPartyId;
        }
        dispatch(BreadcrumbReset())
    }, []);

    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {
            if (lastFetchedPartyIdRef.current !== commonPartyDropSelect.value) {
                lastFetchedPartyIdRef.current = commonPartyDropSelect.value;
                dispatch(GetVenderSupplierCustomer({ subPageMode, RouteID: "", PartyID: commonPartyDropSelect.value }));
                goButtonHandler();
            }
        } else {
            lastFetchedPartyIdRef.current = null;
            dispatch(challanList_ForListPageSuccess([]));
        }
    }, [commonPartyDropSelect]);

    const { Actionhandler } = useCheckStockEntry(commonPartyDropSelect);


    useEffect(() => {

        if (makeGRN.Status === true && makeGRN.StatusCode === 200) {
            history.push({
                pathname: makeGRN.path,
                page_Mode: makeGRN.page_Mode,
            })
        }
    }, [makeGRN])



    useEffect(() => {
        if (deleteMsg.Status === true && deleteMsg.StatusCode === 200) {
            goButtonHandler()
        }

    }, [deleteMsg])

    useEffect(() => {
        const res = sendToScmMsg;
        if (!res || !res.Status) return;
        if (res.Status === true && res.StatusCode === 200) {
            customAlert({
                Type: 1,
                Message: res.Message
            });
            goButtonHandler();
        }
        else {
            customAlert({
                Type: 3,
                Message: res.Message
            });
        }

        // 🔥 Reset state (VERY IMPORTANT)
        dispatch(InvoiceSendToScmSuccess({ Status: false }));

    }, [sendToScmMsg]);

    useEffect(() => {

        const res = reducers.challanBulkData;

        if (!res || !res.StatusCode) return;

        // ✅ SUCCESS
        if (res.Status === true && res.StatusCode === 200) {

            history.push(url.CSS_BULK_INVOICE);

        }

        // ❌ ERROR
        else if (res.Status === false) {

            let htmlMessage = `<div style="text-align:left">`;

            htmlMessage += `<p style="color:red"><b>${res.Message}</b></p>`;

            if (res.Data?.length) {

                res.Data.forEach(item => {

                    htmlMessage += `<p><b>Item : ${item.ItemName}</b></p>`;

                    item.Rates.forEach(rate => {

                        htmlMessage += `
                        <p style="margin-left:10px">
                        Rate ₹${rate.Rate} →
                        Challans : <b>${rate.Challans.join(", ")}</b>
                        </p>
                    `;

                    });

                    htmlMessage += `<hr/>`;

                });

            }

            htmlMessage += `</div>`;

            customAlert({
                Type: 9,
                Message: htmlMessage
            });

        }

        dispatch(challanMasterBulkSuccess(null));

    }, [reducers.challanBulkData]);

    useEffect(() => {   // Uploaded E-way Bill useEffect 

        if ((Uploaded_EwayBill.Status === true) && (Uploaded_EwayBill.StatusCode === 200)) {
            dispatch(Uploaded_EwayBillSuccess({ Status: false }))
            goButtonHandler()
            customAlert({
                Type: 1,
                Message: JSON.stringify(Uploaded_EwayBill.Message),
            })
        }

        else if (Uploaded_EwayBill.Status === true) {
            dispatch(Uploaded_EwayBillSuccess({ Status: false }))
            customAlert({
                Type: 3,
                Message: JSON.stringify(Uploaded_EwayBill.Message),
            })
            return
        }
    }, [Uploaded_EwayBill]);

    useEffect(() => {    // Uploaded Cancel E-way Bill useEffect 

        if (Cancel_EwayBill.Status === true && Cancel_EwayBill.StatusCode === 200) {
            dispatch(Cancel_EwayBillSuccess({ Status: false }))
            goButtonHandler()
            customAlert({
                Type: 1,
                Message: Cancel_EwayBill.Message,
            })
            return
        }
        else if (Cancel_EwayBill.Status === true) {
            dispatch(Cancel_EwayBillSuccess({ Status: false }))
            customAlert({
                Type: 3,
                Message: JSON.stringify(Cancel_EwayBill.Message),
            })
            return
        }
    }, [Cancel_EwayBill]);

    const venderOptions = vendorSupplierCustomer.map((i) => ({
        value: i.id,
        label: i.Name,
    }));

    venderOptions.unshift({
        value: "",
        label: " All"
    });

    const bulkInvoice_Handler = (allList = []) => {
        const selectedRows = allList.filter(row => row.ExtraSelect);

        if (!selectedRows.length) {
            customAlert({
                Type: 4, // warning
                Message: "Please select at least one challan"
            });
            return;
        }

        const idString = selectedRows.map(row => row.id).join(",");

        // Stock entry check runs first; the bulk invoice action only fires if it passes
        Actionhandler({
            transactionDate: date_ymd_func(),
            callback: () => {
                dispatch(
                    challanMasterBulkAction({
                        jsonBody: JSON.stringify({ ChallanIDs: idString }),
                    })
                );
            }
        });
    };

    const makeBtnFunc = (list = []) => {

        const grnRef = [{
            Challan: list[0].id,
            Inward: true,
            GRN_From: subPageMode,
            Invoice_NO: list[0].FullChallanNumber
        }];

        const jsonBody = JSON.stringify({
            OrderIDs: list[0].id.toString(),
            Mode: 2
        });
        if (subPageMode === url.IB_INVOICE_FOR_GRN) {
            Actionhandler({
                transactionDate: date_ymd_func(),  // ✅ pass date per-call
                action: makeGRN_Mode_1Action,
                params: {
                    jsonBody,
                    pageMode: mode.modeSTPsave,
                    grnRef,
                    path: url.IB_GRN,
                },
            });
        } else {
            Actionhandler({
                transactionDate: date_ymd_func(),  // ✅ pass date per-call
                action: makeGRN_Mode_1Action,
                params: {
                    jsonBody,
                    pageMode: mode.modeSTPsave,
                    grnRef,
                    path: url.GRN_ADD_1,
                },
            });
        }
    };

    const deleteBtnFunc = async (config) => {
        const { rowData } = config;

        const alertRepsponse = await customAlert({
            Type: 8,
            Message: `${alertMessages.deleteOrNot} challan : "${rowData.FullChallanNumber}"`,
        });

        if (!alertRepsponse) return;

        Actionhandler({
            transactionDate: date_ymd_func(),
            callback: () => {
                dispatch(deleteChallanId({ ...config }));
            }
        });
    };

    function goButtonHandler() {
        if (loginSelectedPartyID() === 0) {
            customAlert({ Type: 3, Message: alertMessages.commonPartySelectionIsRequired });
            return;
        }

        let json = {}
        let ChallanMode = 0;

        if (subPageMode === url.CHALLAN_MASTER_LIST) {
            ChallanMode = 1;
        }
        else if (subPageMode === url.IB_INVOICE_LIST) {
            ChallanMode = 0;
        }
        else if (subPageMode === url.VDC_INVOICE_LIST) {
            ChallanMode = 2;
        }

        const jsonBody_1 = JSON.stringify({
            FromDate: fromdate,
            ToDate: todate,
            Customer: loginSelectedPartyID(),
            Party: venderSelect === "" ? '' : venderSelect.value,
            IsVDCChallan: (subPageMode === url.IB_INVOICE_FOR_GRN) ? 0 : 1,
            ChallanMode: ChallanMode
        });

        const jsonBody_2 = JSON.stringify({
            FromDate: fromdate,
            ToDate: todate,
            Party: loginSelectedPartyID(),
            Customer: venderSelect === "" ? '' : venderSelect.value,
            IsVDCChallan: 0,
            ChallanMode: ChallanMode
        });

        if (subPageMode === url.VDC_INVOICE_LIST || subPageMode === url.IB_INVOICE_FOR_GRN) {
            json = jsonBody_1

        } else {
            json = jsonBody_2

        }
        dispatch(challanList_ForListPage(json));
    }

    const selecthandler = ({ event, rowData, tableList }) => {

        const list = reducers.tableList || [];
        const isChecked = event.currentTarget.checked;
        const customerId = rowData.CustomerID;

        if (rowData.InvoiceCreated) return;

        const existingCustomerId = list.find(row =>
            selectedChallanIdsRef.current.has(row.id)
        )?.CustomerID;

        if (isChecked) {

            if (existingCustomerId && existingCustomerId !== customerId) {
                selectedChallanIdsRef.current.clear();
            }

            list.forEach(row => {
                if (
                    row.CustomerID === customerId &&
                    !row.forceExtraSelectDissabled
                ) {
                    selectedChallanIdsRef.current.add(row.id);
                }
            });

        } else {
            selectedChallanIdsRef.current.delete(rowData.id);
        }

        const updatedTableList = list.map(row => ({
            ...row,
            ExtraSelect: selectedChallanIdsRef.current.has(row.id),
            selectCheck: selectedChallanIdsRef.current.has(row.id)
        }));

        dispatch(challanList_ForListPageSuccess(updatedTableList));
    };

    const headerselecthandler = ({ event }) => {

        const list = reducers.tableList || [];
        const isChecked = event.currentTarget.checked;

        selectedChallanIdsRef.current.clear();

        if (isChecked) {

            const firstValidRow = list.find(row => !row.InvoiceCreated);

            if (!firstValidRow) return;

            const customerId = firstValidRow.CustomerID;

            list.forEach(row => {
                if (
                    row.CustomerID === customerId &&
                    !row.forceExtraSelectDissabled
                ) {
                    selectedChallanIdsRef.current.add(row.id);
                }
            });
        }

        const updatedTableList = list.map(row => ({
            ...row,
            ExtraSelect: selectedChallanIdsRef.current.has(row.id),
            selectCheck: selectedChallanIdsRef.current.has(row.id)
        }));

        dispatch(challanList_ForListPageSuccess(updatedTableList));
    };
    function downBtnFunc(config) {
        if (subPageMode === url.CHALLAN_MASTER_LIST && (isRACompany() || isFoodERPDotIn())) {
            config["ReportType"] = report.RAChallan;
        } else {
            config["ReportType"] = report.invoice;
        }
        config["SubPageMode"] = subPageMode;
        dispatch(getpdfReportdata(IB_Invoice_Singel_Get_for_Report_Api, config))
    }

    function fromdateOnchange(e, date) {
        let newObj = { ...hederFilters }
        newObj.fromdate = date
        setHederFilters(newObj)
    }

    function todateOnchange(e, date) {
        let newObj = { ...hederFilters }
        newObj.todate = date
        setHederFilters(newObj)
    }

    function venderOnchange(e) {
        let newObj = { ...hederFilters }
        newObj.venderSelect = e
        setHederFilters(newObj)
    }

    function sendToScmBtnFunc(config) {

        const { rowData, btnId } = config;

        let jsonBody = {};

        if (IsSweetAndSnacksCompany()) {
            jsonBody = JSON.stringify({
                InvoiceID: rowData.id,
                TransactionType: "Challan"
            });
        } else {
            jsonBody = JSON.stringify({
                Invoice: rowData.id
            });
        }

        Actionhandler({
            transactionDate: date_ymd_func(),
            callback: () => {
                dispatch(InvoiceSendToScm({ jsonBody, btnId }));
            }
        });
    }


    return (

        <React.Fragment>
            <PageLoadingSpinner isLoading={reducers.listBtnLoading || !pageField} />
            <div className="page-content">

                <div className="px-2  c_card_filter text-black " >
                    <div className="row">
                        <div className=" row">
                            <Col sm="3" className="">
                                <FormGroup className="mb- row mt-3 " >
                                    <Label className="col-sm-5 p-2"
                                        style={{ width: "83px" }}>FromDate</Label>
                                    <Col sm="7">
                                        <C_DatePicker
                                            name='fromdate'
                                            value={fromdate}
                                            onChange={fromdateOnchange}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col sm="3" className="">
                                <FormGroup className="mb- row mt-3 " >
                                    <Label className="col-sm-5 p-2"
                                        style={{ width: "65px" }}>ToDate</Label>
                                    <Col sm="7">
                                        <C_DatePicker
                                            nane='todate'
                                            value={todate}
                                            onChange={todateOnchange}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>

                            <Col sm="5">
                                <FormGroup className="mb-2 row mt-3 " >
                                    <Label className="col-md-4 p-2"
                                        style={{ width: "115px" }}>Customer</Label>
                                    <Col md="5">
                                        <Select
                                            value={venderSelect}
                                            classNamePrefix="select2-Customer"
                                            options={venderOptions}
                                            onChange={venderOnchange}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 2 })
                                            }}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col >

                            <Col sm="1" className="mt-3 ">
                                <Go_Button
                                    onClick={goButtonHandler}
                                    loading={reducers.goBtnLoading}
                                />
                            </Col>
                        </div>

                    </div>
                </div>
                {
                    (pageField) ?
                        <CommonPurchaseList
                            action={action}
                            reducers={reducers}
                            showBreadcrumb={false}
                            masterPath={otherState.masterPath}
                            newBtnPath={otherState.newBtnPath}
                            // makeBtnShow={otherState.makeBtnShow}
                            pageMode={pageMode}
                            downBtnFunc={downBtnFunc}
                            // goButnFunc={goButtonHandler}
                            makeBtnFunc={makeBtnFunc}
                            ButtonMsgLable={"challan"}
                            hideChallanFlags={subPageMode === url.CHALLAN_MASTER_LIST}
                            makeBtnName={"Make GRN"}
                            deleteName={"FullChallanNumber"}
                            MasterModal={Challan}
                            forceNewBtnView={subPageMode === url.VDC_INVOICE_LIST ? true : false}
                            selectCheckParams={{
                                isExtraSelectShow: isChallanList,       // ✅ ExtraSelect checkbox
                                ExtraSelectBtnHandler: bulkInvoice_Handler,
                                ExtraSelectLabel: "Select",
                                headerselecthandler,
                                selecthandler,
                            }}
                            sendToScmBtnFunc={sendToScmBtnFunc}
                            totalAmountShow={true}
                            deleteBtnFunc={deleteBtnFunc}
                        />

                        : null

                }
                {
                    isChallanList && reducers.tableList?.length > 0 && (
                        <SaveButtonDraggable>
                            <C_Button
                                type="button"
                                className="btn btn-primary"
                                spinnerColor="white"
                                loading={reducers.bulkInvoiceLoading}
                                disabled={reducers.bulkInvoiceLoading}
                                onClick={() => bulkInvoice_Handler(reducers.tableList)}
                            >
                                Bulk Invoice
                            </C_Button>
                        </SaveButtonDraggable>
                    )
                }
            </div>
        </React.Fragment>
    )
}

export default IBInvoiceList;